import { render, staticRenderFns } from "./log-manage.vue?vue&type=template&id=54cd7b2a&scoped=true"
import script from "./log-manage.vue?vue&type=script&lang=js"
export * from "./log-manage.vue?vue&type=script&lang=js"
import style0 from "./log-manage.vue?vue&type=style&index=0&id=54cd7b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd7b2a",
  null
  
)

export default component.exports